<template>
  <div class="app" :style="appStyle">
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      safeArea: (state) => state.layout.safeArea,
    }),
    appStyle() {
      return {
        "--safeTop": this.safeArea.top + "px",
        "--safeBottom": this.safeArea.bottom + "px",
      };
    },
  },
};
</script>

<style>
.app {
  width: 100%;
  height: 100%;
}
</style>
